module.exports = __webpack_public_path__ + "img/ico-arrow-down.8872911f.svg";